(function() {
	/*
     * SUG Items Per Page
     * Description: Generates a Items Per Page UI control for use with SUG data lists.
     *
	 * Requires the following libs:
     * ui-bootstrap
     * SUGUtilities (app.js)
     *
     * Attributes:
     *  @options - Object Array required; An Array of object to define the per-page increments show in the directive; one-way binding
     *  @contentLength - Integer required; Array length of the unfiltered data array used for the list view table; one-way binding
     *  @numPerPage - Integer required; Model variable that maps to the frmObj.numPerPage value (or similar); two-way binding
     *  @onSetPerPage - Function, required, function to change the number per page when an option is clicked (will pass in that option's count number)
     *
     * Usage: <items-per-page options="{{::perPageOptions}}" content-length="modalParticipants.length" num-per-page="{{frmObj.numPerPage}}" on-set-per-page="setPerPage()"></items-per-page>
	 */
	SUGApp.directive('itemsPerPage', ['SUGUtilities', function(SUGUtilities) {
		return {
			restrict: 'E',
			templateUrl: '/view/templates/ngtemplates/items-per-page.html',
			scope: {
                ippOptions: '<options',
                ippDataLength: '<contentLength',
                ippNumberPerPage: '<numPerPage',
                onSetPerPage: '&'
            },
			link: function(scope, element, attrs) {

				/**
                 * Runs first
                 */
				function init(){
                    unwrapHandlers();

                    var styles = [
                        {selector: ".ipp ", rule: "display: block; float: left; line-height: 1.6rem; padding-top: 6px; margin: 0 16px 8px 16px;"},
                        {selector: ".ipp li ", rule: "display: inline-block; padding: 6px;"},
                        {selector: ".ipp li + li ", rule: "width: 30px; height: 30px; border-radius: 30px; border: 1px solid transparent; text-align: center; margin-right: 2px; transition: background-color .2s, color .2s, opacity .2s, border-color .2s;"},
                        {selector: ".ipp li + li:hover , .ipp li + li:active ", rule: "cursor: pointer; opacity: .9;"},
                        //styles below here could be overridden to customize colors with theme settings, etc (ex. participantDetailsModalController.js)
                        {selector: ".ipp li ", rule: "color: #222222;"},
                        {selector: ".ipp li + li ", rule: "color: #222222;"},
                        {selector: ".ipp li:hover:not(.active), .ipp li:active:not(.active) ", rule: "color: #FFFFFF;"},
                        {selector: ".ipp li.active ", rule: "color: #FFFFFF !important; border: 1px solid #F68B1C !important;  background-color: #F68B1C;"},
                        {selector: ".ipp li:hover:not(.active), .ipp li:active:not(.active) ", rule: "border: 1px solid #FFFFFF; background-color: #F68B1C;"},
                        //keep the first-child style last
                        {selector: ".ipp li:first-child, .ipp li:first-child:hover ", rule: "cursor: auto; color: #222222; background: transparent; border: none;"}
                    ];
                    SUGUtilities.addDirectiveStyles(['sugstylev3.min.css', 'sugstylev3-responsive.min.css'], styles ,'.ipp' , 1);
                }

                /**
                 * Determines if we should show the items per page markup
                 */
                scope.showItemsPerPage = function(){
                    return ( Array.isArray( scope.ippOptions )
                             && Number.isInteger( scope.ippDataLength )
                             && scope.ippOptions.length > 1
                             && scope.ippDataLength > scope.ippOptions[1].count
                            ) ? true : false;
                };

                /**
                 * Unwrap the event handler(s) so that we can pass in parameters inside the directive markup
                 */
                function unwrapHandlers(){
                    scope.onSetPerPage = scope.onSetPerPage();
                }

                //fire init
				init();
            }
        };
    }]);

}());
